import React, { useState, useCallback, useContext, createContext } from 'react';

const ProgressBarContext = createContext(null);

export const ProgressBarProvider = ({ children }) => {
  const [progress, setProgress] = useState({
    open: false,
    current: 0,
    total: 0,
    status: 'processing', // 'processing' | 'success' | 'error'
    message: '',
    errorMessage: '',
  });

  const openProgress = useCallback((total, message = '') => {
    setProgress({
      open: true,
      current: 0,
      total,
      status: 'processing',
      message,
      errorMessage: '',
    });
  }, []);

  const updateProgress = useCallback((current, message = '') => {
    setProgress((prev) => ({
      ...prev,
      current,
      message: message || prev.message,
    }));
  }, []);

  const closeProgress = useCallback(() => {
    setProgress((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  const setSuccess = useCallback((message = '') => {
    setProgress((prev) => ({
      ...prev,
      status: 'success',
      message,
      errorMessage: '',
    }));
  }, []);

  const setError = useCallback((errorMessage = '') => {
    setProgress((prev) => ({
      ...prev,
      status: 'error',
      errorMessage,
    }));
  }, []);

  return (
    <ProgressBarContext.Provider
      value={{ progress, openProgress, updateProgress, closeProgress, setSuccess, setError }}
    >
      {children}
    </ProgressBarContext.Provider>
  );
};

export const useProgressBar = () => {
  const context = useContext(ProgressBarContext);
  if (!context) {
    throw new Error('useProgressBar deve ser usado dentro de um ProgressBarProvider');
  }
  return context;
};
